import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <div className='loader__page'>
            <h1 className='loader'>
                <span>W</span>
                <span>a</span>
                <span>i</span>
                <span>t</span>
                <span>.</span>
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </h1>
        </div>
    );
};

export default Loader;